// services
import AnalyticsService from 'modules/Analytics/service';
// utils
import { getStringSizeInKb } from 'modules/TradingChart/components/utils/ChartSizeCalculator';
// constants
import { EVENTS } from 'modules/Analytics/consts';
// typings
import {
  ChartData,
  StudyTemplateData,
} from '../../../sources/charting_library.min';

class TrackTVChartSaveEvents {
  getServerPreferenceObject(isServer: boolean) {
    return {
      preference: isServer ? 'cloudStorage' : 'localStorage',
    };
  }

  sendTotalChartSavedMixpanelEvent(chartsCount: number, isServer: boolean) {
    AnalyticsService.sendEvent(
      EVENTS.TOTAL_TV_CHARTS_SAVED,
      {
        'Total charts': chartsCount,
        ...this.getServerPreferenceObject(isServer),
      },
      true,
    );
  }

  sendSaveChartWithSizeMixpanelEvent(chartData: ChartData, isServer: boolean) {
    if (!chartData) return;

    const chartSizeInKb = getStringSizeInKb(chartData?.content || '');

    AnalyticsService.sendEvent(
      EVENTS.SAVED_TV_CHART_SIZE,
      {
        'Chart layout name': chartData.name,
        'Chart size(KB)': chartSizeInKb,
        ...this.getServerPreferenceObject(isServer),
      },
      true,
    );
  }

  sendTotalTemplatesSavedMixpanelEvent(
    templatesCount: number,
    isServer: boolean,
  ) {
    AnalyticsService.sendEvent(
      EVENTS.TOTAL_TV_STUDY_TEMPLATES_SAVED,
      {
        'Total study templates': templatesCount,
        ...this.getServerPreferenceObject(isServer),
      },
      true,
    );
  }

  sendSaveTemplateWithSizeMixpanelEvent(
    templateData: StudyTemplateData,
    isServer: boolean,
  ) {
    if (!templateData) return;

    const templateSizeInKb = getStringSizeInKb(templateData?.content || '');

    AnalyticsService.sendEvent(
      EVENTS.SAVED_TV_STUDY_TEMPLATE_SIZE,
      {
        'Study template name': templateData.name,
        'Study template size(KB)': templateSizeInKb,
        ...this.getServerPreferenceObject(isServer),
      },
      true,
    );
  }
}

export default new TrackTVChartSaveEvents();
